
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Slide, SlideLine, Group } from 'app/models/slideLine.model';
import { mainColumns, entryColumns, exitColumns, miscColumns } from 'app/config/slide-columns.config';
import { forkJoin } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({ providedIn: 'root' })
export class SlideService {
  //private baseUrl = '/api';
  private apiUrl = `${environment.baseUrl}/slideLines`;



  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }


  loadSlide(projectId: string, slideId: string): Observable<Slide> {
    console.log(`${this.apiUrl}/getSlideHeaderforProjectSlide`);

    // const header$ = this.http.post<any[]>(`${this.apiUrl}/getSlideHeaderforProjectSlide`, {
    //   projectId,
    //   slideId
    // });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = {
      "criteria": {
        tenant: null,
        "projectId": projectId,
        "slideId": slideId
              }
    };

    let header$ = this.commonAPI.postApiCall(`${this.apiUrl}/getSlideHeaderforProjectSlide`, body);

    // const header$ = this.commonAPI.postApiCall(`${this.apiUrl}/getSlideHeaderforProjectSlide`, { projectId, slideId });

    // const lines$ =
    //   this.http.post<any[]>(`${this.apiUrl}/getSlideLinesforProjectSlide`, {
    //     projectId,
    //     slideId
    //   })
    let lines$ = this.commonAPI.postApiCall(`${this.apiUrl}/getSlideLinesforProjectSlide`, body);

    // const lines$ = this.commonAPI.postApiCall(`${this.apiUrl}/getSlideLinesforProjectSlide`, { projectId, slideId });

    return forkJoin([header$, lines$]).pipe(
      map(([header, lines]) => {
        // 1. Convert raw DB rows into SlideLine objects
        const mappedLines = this.mapLines(lines);

        // 2. Build tree from flat lines (parentId → children[])
        const treeLines = this.buildTree(mappedLines);

        const h = header[0];
        const titleRaw = h.slideTitle ?? h.SlideTitle ?? '';
        const slide: Slide = {
          projectId: h.projectId,
          slideId: h.ProjectSlideId,
          slideTitle: String(titleRaw ?? '').trim(),
          slideType: h.slideType,
          lines: treeLines,
        };
        return slide;
      })
    );
  }

  generateAudioForSlide(projectId: string, slideId: string, strategy: 'SLIDE' | 'LINE' = 'SLIDE'): Observable<any> {
    const body = {
      criteria: {
        tenant: null,
        projectId,
        slideId,
        strategy,
      }
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/generateAudioForSlide`, body);
  }

  translateSlideForLanguage(projectId: string, slideId: string, languageShortCode: string): Observable<any> {
    const body = {
      criteria: {
        tenant: null,
        projectId,
        slideId,
        languageShortCode,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/translateSlideForLanguage`, body);
  }

  generateTranslatedAudioForSlide(projectId: string, slideId: string, languageShortCode: string): Observable<any> {
    const body = {
      criteria: {
        tenant: null,
        projectId,
        slideId,
        languageShortCode,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/generateTranslatedAudioForSlide`, body);
  }

  regenerateAudioForLine(projectId: string, slideId: string, lineSrNo: number): Observable<any> {
    const body = {
      criteria: {
        tenant: null,
        projectId,
        slideId,
        lineSrNo,
      }
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/regenerateAudioForLine`, body);
  }

  private mapLines(raw: any[]): SlideLine[] {
    const allConfigs = [...mainColumns, ...entryColumns, ...exitColumns, ...miscColumns];
    return raw.map(row => {
      const line: SlideLine = {
        id: row.PSLSrNo,
        kind: row.PSLkind === 'OG' ? 'OG' : 'SL',
        PSLname: row.PSLName,
        PSLrawName: row.PSLrawName,          // child raw name (if in group)
        PSLNodeval: row.PSLNodeval,
        PSLLevel: row.PSLLevel,
        PSLparentId: row.PSLParentId,
        order: row.PSLOrder,
        PSLtype: row.PSLtype,
        //PSLValue: string; PSLSourceType: string;
        main: { Name: row.PSLrawName, Type: row.PSLtype, Value: row.PSLValue, SrcType: row.PSLSourceType },
        entry: { EntShowWith: row.PSLShowWith, EntShowAfter: row.PSLShowAfter, EntDelay: row.PSLShowDelay },
        exit: { ExitShowWith: row.PSLExitWith, ExitShowAfter: row.PSLExitAfter, ExitDelay: row.PSLExitDelay },
        misc: { AudioOptions: row.PSLAudioDirect, AudioText: row.PSLAudioValue, HyperLink: row.PSLHyperlink },
        children: [],
        isOpen: true
      };

      allConfigs.forEach(cfg => {
        (line[cfg.group] as any)[cfg.key] = row[cfg.field];
      });

      return line;
    });
  }


  private buildTree(lines: SlideLine[]): SlideLine[] {
    const map = new Map<number, SlideLine>();
    const roots: SlideLine[] = [];

    // index all lines
    lines.forEach(line => {
      line.children = [];
      line.isOpen = true; // default open
      map.set(line.id, line);
    });

    // assign children to parents
    lines.forEach(line => {
      if (line.PSLparentId) {
        const parent = map.get(line.PSLparentId);
        if (parent) {
          parent.children!.push(line);
        }
      } else {
        roots.push(line);
      }
    });
    lines.forEach(line => {
      if (line.kind == 'OG') {
        line.isOpen = false;
      }
    });

    return roots;
  }

  addTopLevelLine(projectId: string, slideId: string, linename: string): Observable<SlideLine> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = {
      "criteria": {
        "projectId": projectId,
        "slideId": slideId,
        "linename": linename,
        tenant: null
      }
    };

    let aaa = this.commonAPI.postApiCall(`${this.apiUrl}/pushEmptySlideLinesSL`, body);
    return aaa;

   // return this.commonAPI.postApiCall(`${this.apiUrl}/projects/${projectId}/slides/${slideId}/linename/${linename}`, { kind: 'line' });
    // return this.http.post<SlideLine>(`${this.apiUrl}/projects/${projectId}/slides/${slideId}/linename/${linename}`, {
    //   kind: 'line'
    // });
  }

  addTopLevelGroup(projectId: string, projectSlideId: string, groupName: string, order: number, afterlinesrno: number): Observable<SlideLine> {
    // Backend returns a group with its children (lines inside the group)

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = {
      "criteria": {
    "projectId":projectId, 
    "projectSlideId":projectSlideId, 
    "groupName":groupName, 
    "order":order, 
    "afterlinesrno":afterlinesrno,
                tenant: null
      }
    };

    let aaa = this.commonAPI.postApiCall(`${this.apiUrl}/pushEmptySlideLinesforObjectGroup`, body);
    return aaa;

    // return this.http.post<any>(`${this.apiUrl}/pushEmptySlideLinesforObjectGroup`, {
    //   projectId, projectSlideId, groupName, order, afterlinesrno
    // })
  }


  deleteLine(projectId: string, projectSlideId: string, linesrno: number, order: number): Observable<SlideLine[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = {
      "criteria": {
        "projectId": projectId,
        "projectSlideId":projectSlideId, 
        "linesrno":linesrno, 
        "order":order,
        tenant: null
      }
    };

    let aaa = this.commonAPI.postApiCall(`${this.apiUrl}/deleteSlidelineforProjectSlide`, body);
  return aaa;
   
    // return this.http.post<any[]>(`${this.apiUrl}/deleteProjectSlide`, {
    //   projectId, projectSlideId, linesrno, order
    // })
  }


  
  flattenLines(lines: SlideLine[]): SlideLine[] {
    return lines.flatMap(line =>
      line.kind === 'OG' && line.children?.length
        ? [line, ...this.flattenLines(line.children)]
        : [line]
    );
  }
  getTranslatedLanguagesForProjectSlide(projectId: string, slideId: string): Observable<any[]> {
    const body = {
      criteria: {
        tenant: null,
        projectId,
        slideId,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/getTranslatedLanguagesForProjectSlide`, body);
  }

  getTranslatedValsForProjectSlide(
    projectId: string,
    slideId: string,
    languageShortCode: string,
  ): Observable<any[]> {
    const body = {
      criteria: {
        tenant: null,
        projectId,
        slideId,
        languageShortCode,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/getTranslatedValsForProjectSlide`, body);
  }

  updateAllLines(
    projectId: string,
    projectSlideId: string,
    slidelines: SlideLine[],
    languageShortCode = '',
  ): Observable<void> {

const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {

        "projectId": projectId,
        "projectSlideId": projectSlideId,
        "slidelines": slidelines,
        "languageShortCode": languageShortCode || '',
                "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/updateProjectSlideLines`, body);
    
    // return this.http.post<void>(`${this.apiUrl}/updateProjectSlideLines`, {
    //   projectId,
    //   projectSlideId,
    //   slidelines
    // });
  }


  reorderSiblings(projectId: string, slideId: string, parentId: number | null, orderedIds: number[]): Observable<void> {

const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {

        "projectId": projectId,
        "projectSlideId": slideId,
        "parentId": parentId,
        "orderedIds":orderedIds,
                "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/reorder`, body);


    
    // return this.http.post<void>(`${this.apiUrl}/projects/${projectId}/slides/${slideId}/reorder`, {
    //   parentId,
    //   orderedIds
    // });
  }

  getAvailableGroups(projectId: string, slideId: string): Observable<Group[]> {
    // debugger;
    console.log(`${this.apiUrl}/getAvailableGroups/${projectId}`);


    return this.commonAPI.postApiCall(`${this.apiUrl}/getAvailableGroups`, { projectId, slideId });
    // return this.http.post<Group[]>(`${this.apiUrl}/getAvailableGroups`, {
    //   projectId, slideId
    // })
  }

}
